import createModel from 'utils/model'
import _ from 'lodash'
import {getTableData, deleteRecord, contactWaysExport} from 'crm/services/drainage-contact-me'
import {info as weworkInfo, update as updateWeworkInfo} from 'crm/services/wechat-setting'

function getInitTableParamsState() {
    return {
        keyword: undefined,
        channel_id: undefined,
        limit: 10,
        offset: 0,
    }
}

function getInitTableState() {
    return {
        params: getInitTableParamsState(),
        total: 0,
        current: 1,
        tableData: [],
    }
}

export default createModel({
    namespace: 'crm_drainage_contactMe',

    state: {
        ...getInitTableState(),
    },

    effects: {
        *getTableData({payload}, {select, call, put}) {
            const {params, current} = yield select(
                ({crm_drainage_contactMe}) => crm_drainage_contactMe,
            )

            const newParams = {...params}

            if (payload.page) {
                newParams.offset = newParams.limit * (payload.page - 1)
            }

            const query = {...newParams}
            const {keyword} = query
            if (typeof keyword === 'string') {
                query.keyword = keyword.trim()
            }

            const res = yield call(getTableData, query)

            yield put({
                type: 'setProperty',
                payload: {
                    tableData: res.data,
                    params: newParams,
                    total: _.get(res, 'pagination.rows_found', 0),
                    current: _.get(payload, 'page', current),
                },
            })
        },

        *contactWaysExport(x, {select, call}) {
            const {params} = yield select(({crm_drainage_contactMe}) => crm_drainage_contactMe)

            const newParams = {...params}

            delete newParams.limit

            delete newParams.offset

            return yield call(contactWaysExport, {
                body: newParams,
            })
        },

        *deleteRecord({payload}, {call}) {
            return yield call(deleteRecord, payload)
        },
        *weworkInfo(x, {call}) {
            return yield call(weworkInfo)
        },
        *updateWeworkInfo({payload}, {call}) {
            return yield call(updateWeworkInfo, payload)
        },
    },

    reducers: {
        resetTableParams(state) {
            return {...state, params: getInitTableParamsState()}
        },
        resetTable(state) {
            return {...state, ...getInitTableState()}
        },
    },
})
